module.exports = __webpack_public_path__ + "img/alreadySentMobile.2d6c835a.svg";